<template>
  <div>
    <el-dialog title="操作日志" :visible.sync="visible" @close="handleClose">
      <el-table :data="lists">
        <el-table-column prop="admin_name" label="操作人"></el-table-column>
        <el-table-column prop="content" label="变更内容"></el-table-column>
        <el-table-column prop="create_time" label="操作时间"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import ApiHelp from "./../common/Api";
export default {
  props: {
    visible : {
      type : Boolean , default : false ,
    },
    data_id : {
      type : Number , default : 0,
    },
    data_type : {
      type : String , default : '',
    },
  },
  data(){
    return {
      lists : [] ,
      page : 1 ,
      page_size : 10 ,
    };
  },
  watch : {
    data_id : function(val){
      this.getList();
    },
    data_type : function(val){
      this.getList();
    }
  },
  methods: {
    getList(){
      let that = this;
      ApiHelp.operatorLog(this.data_id , this.data_type , this.page , this.page_size , (res)=>{
        that.lists = res.list;
      })
    },
    handleClose(){
      this.$emit('close');
    },
  }
}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/components/OperatorLog.vue